import { render, staticRenderFns } from "./FieldPhone.vue?vue&type=template&id=0fd327bb&scoped=true"
import script from "./FieldPhone.vue?vue&type=script&lang=js"
export * from "./FieldPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd327bb",
  null
  
)

export default component.exports